export default __webpack_public_path__ + "static/media/tenpercent.48e3c54f.gif";